import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { useOrganization, useAuth } from "@clerk/clerk-react";
import { GlobeLock } from "lucide-react";

export default function NetInfo(props) {
  return (
    <Card className="w-full max-w-[316px]">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-xl font-bold ">Grid information</CardTitle>
        <GlobeLock className="ml-4 mb-1 h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex flex-col md:flex-row text-sm font-medium md:gap-x-2">
          Operator <p className="text-sm text-muted-foreground"> {props.operator}</p>
        </div>
        
        <div className="flex flex-col md:flex-row text-sm font-medium md:gap-x-2">
          Voltage <p className="text-sm text-muted-foreground"> {props.voltage}</p>
        </div>
        <div className="flex flex-col md:flex-row text-sm font-medium md:gap-x-2">
          Circuits <p className="text-sm text-muted-foreground"> {props.circuits}</p>
        </div>
        <div className="flex flex-col md:flex-row text-sm font-medium md:gap-x-2">
          Cables <p className="text-sm text-muted-foreground"> {props.cables}</p>
        </div>
        <div className="flex flex-col md:flex-row text-sm font-medium md:gap-x-2">
          Wires <p className="text-sm text-muted-foreground"> {props.wires}</p>
        </div>
        <div className="flex flex-col md:flex-row text-sm font-medium md:gap-x-2">
          Location <p className="text-sm text-muted-foreground"> {props.location}</p>
        </div>
      </CardContent>
    </Card>
  );
}